const DropDownIcon = ({ color, w, h, className }) => {
    return (
        <svg
            width={w}
            height={h}
            viewBox='0 0 7 4'
            fill='none'
            className={className}
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M0.749605 0.70415L1.44554 0.00415039L3.73216 2.30415L6.01879 0.00415039L6.71472 0.70415L3.73216 3.70415L0.749605 0.70415Z'
                fill={color}
            />
        </svg>
    );
};

export default DropDownIcon;
